/* global Sys, Core, Resources */
Sys.ns("Core.Slots");

/**
 * The Server Manager model for slots.
 *
 * @class Core.Slots.ServerManagerModel
 * @extends Core.ServerManagerModel
 */
Core.Slots.ServerManagerModel = {

    /** @inheritdoc */
    constructor: function() {
        Core.Slots.ServerManagerModel.superclass.constructor.apply(this, arguments);
    },

    /** @inheritdoc */
    setupData: function() {
        var me = this,
            initResponse,
            numOfBetlines,
            betLinesReqStr;

        Core.Slots.ServerManagerModel.superclass.setupData.apply(me, arguments);

        initResponse = Resources.readData("gameServerInitResponse");
        numOfBetlines = initResponse["bl.standard"].split(",").length;
        betLinesReqStr = "0-" + (numOfBetlines - 1).toString();

        me.storeData("parameters:betLines", betLinesReqStr);

        me.storeData("nextAction", initResponse.nextaction);
    },

    /**
     * Returns the parameters used for an init request.
     *
     * @protected
     * @param {string} action The requested action.
     * @returns {string} The parameters as a query string.
     */
    getActionParameters: function(action) {
        var baseParameters = this.getBaseParameters(action);

        baseParameters = baseParameters + this.getFreeroundsParameters();

        switch (action) {
            case "init":
                return baseParameters + this.getInitParameters();
            case "jmxinit":
                return baseParameters + this.getJMXInitParameters();
            case "paytable":
                return baseParameters + this.getPaytableParameters();
            case "spin":
                return baseParameters + this.getSpinParameters();
            case "initfreespin":
                return baseParameters + this.getInitFreespinParameters();
            case "respin":
            case "freespin":
                return baseParameters + this.getFreespinParameters();
            case "widgetspin":
                return baseParameters + this.getWidgetspinParameters();
            case "initbonus":
                return baseParameters + this.getInitBonusParameters();
            case "bonusaction":
                return baseParameters + this.getBonusActionParameters();
            default:
                return baseParameters;
        }
    },

    /**
     * Returns the parameters used for all requests made in a slot game.
     *
     * @private
     * @param {string} action The requested action.
     * @returns {string} The parameters as a query string.
     */
    getBaseParameters: function(action) {
        return "action=" + action + "&sessid=" + this.readData("parameter:sessionID") + "&gameId=" + this.readData("parameter:gameID") + "&wantsreels=true";
    },

    /**
     * Returns the freeround specific parameters.
     *
     * @private
     * @returns {string} The parameters in query string format.
     */
    getFreeroundsParameters: function() {
        var params = Resources.readData("extraParams");

        return "&wantsfreerounds=" + params.wantsfreerounds + "&freeroundmode=" + params.freeroundmode;
    },

    /**
     * Returns the extra parameters.
     *
     * @protected
     * @returns {string} The parameters as a query string.
     */
    getInitParameters: function() {
        return "";
    },

    /**
     * Returns the extra parameters used for a jmxinit request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getJMXInitParameters: function() {
        return this.getInitParameters();
    },

    /**
     * Returns the extra parameters used for a paytable request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getPaytableParameters: function() {
        return "";
    },

    /**
     * Returns the extra parameters used for a spin request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getSpinParameters: function() {
        var me = this,
            parameters = "&bet.betlevel=" + me.readData("parameters:betLevel") +
                "&bet.denomination=" + me.readData("parameters:denomination") +
                "&bet.betlines=" + me.readData("parameters:betLines"),
            jmx = me.readData("parameter:jmx");

        if (jmx) {
            parameters += "&" + jmx;
        }

        return parameters;
    },

    /**
     * Returns the extra parameters used for an initfreespin request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getInitFreespinParameters: function() {
        return this.getInitParameters();
    },

    /**
     * Returns the extra parameters used for a freespin request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getFreespinParameters: function() {
        var parameters = this.getInitParameters(),
            jmx = this.readData("parameter:jmx");

        if (jmx) {
            parameters += "&" + jmx;
        }

        return parameters;
    },

    /**
     * Returns the extra parameters used for an initbonus request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getInitBonusParameters: function() {
        var parameters = "&bonusid=" + this.readData("parameter:bonusid"),
            jmx = this.readData("parameter:jmx");

        if (jmx) {
            parameters += "&" + jmx;
        }

        return parameters;
    },

    /**
     * Returns the extra parameters used for an bonusaction request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getBonusActionParameters: function() {
        var parameters = "",
            bonusactiontype = this.readData("parameter:bonusactiontype"),
            jmx = this.readData("parameter:jmx");

        if (bonusactiontype) {
            parameters += "&bonusactiontype=" + bonusactiontype;
        }

        if (jmx) {
            parameters += "&" + jmx;
        }

        return parameters;
    },

    /**
     * Returns the extra parameters used for an widgetspin request.
     *
     * @private
     * @returns {string} The parameters as a query string.
     */
    getWidgetspinParameters: function() {
        return "&bonusProgramId=" + Resources.readData("gameServerInitResponse").bonusProgramId;
    }
};

Core.Slots.ServerManagerModel = Sys.extend(Core.ServerManagerModel, Core.Slots.ServerManagerModel, "Core.Slots.ServerManagerModel");
